import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async'; 

import './index.css';
import './shared/styles/Common.css';

import { PhotoSelection, PhotoConfirmation, UploadSuccess, UploadFailed } from './features/user-upload';
import { LandingPage } from './features/landing';

import backGroundImg2 from './img/back_ground2.png';
import { Screen } from './features/admin-screen';
import { LoginPage, ForgotPassword, ResetPasswordConfirm } from './features/auth';
import RequireAuth from './shared/components/hoc/RequireAuth';
import { ModerationDashboard, SwipeCheck } from './features/admin-moderation';
import { HeartAnimationScreen } from './features/heart-animation';
// import { Signup, ConfirmSignup } from './features/auth';
import { PhotoGallery } from './features/user-gallery';
import { UserMenu } from './features/user-menu';
import { CommentInput } from './features/user-comment';

import { RoomAdmin } from './features/admin-room';
import { ScatterGalleryScreen } from './features/scatter-gallery';
import { QRPaperDesignSelect, QRPaperOrderForm, QRPaperConsentForm, QRPaperConfirmForm } from './features/admin-qr-paper';
import MasonryGalleryDemo from './pages/MasonryGalleryDemo';


// RoomContext をインポート
import { RoomProvider } from './contexts/RoomContext';
import { ImageUpdateProvider } from './contexts/ImageUpdateContext';


const AppWrapper = () => {
  const location = useLocation();

  const isGalleryPage = location.pathname.startsWith("/admin/gallery") ||
    location.pathname.startsWith("/user/menu");

  const style = !isGalleryPage ? { backgroundImage: `url(${backGroundImg2})` } : undefined;

  return (
    <div className="App" style={style}>
      <Routes>
        {/* ランディングページをルートに配置 */}
        <Route path="/" element={<LandingPage />} />

        {/* ヘルスチェック専用エンドポイント */}
        <Route path="/healthz" element={<div>OK</div>} />
        
        {/* 認証関連のルート */}
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth/forgotPassword" element={<ForgotPassword />} />
        <Route path="/auth/resetPasswordConfirm" element={<ResetPasswordConfirm />} />
        {/* <Route path="/auth/signup" element={<Signup />} /> */}
        {/* <Route path="/auth/confirmSignup" element={<ConfirmSignup />} /> */}
        
        {/* ユーザー機能のルート */}
        <Route path="/user/menu" element={<UserMenu />} />
        <Route path="/user/comment-input" element={<CommentInput />} />
        <Route path="/user/photo-selection" element={<PhotoSelection />} />
        <Route path="/user/photo-confirmation" element={<PhotoConfirmation />} />
        <Route path="/user/upload-success" element={<UploadSuccess />} />
        <Route path="/user/upload-failed" element={<UploadFailed />} />
        <Route path="/user/photos" element={<PhotoGallery />} />
        
        {/* 管理機能のルート */}
        <Route path="/admin/room-create" element={<RequireAuth><RoomAdmin /></RequireAuth>} />
        <Route path="/admin/screen" element={<RequireAuth><Screen /></RequireAuth>} />
        <Route path="/admin/gallery" element={<RequireAuth><ModerationDashboard /></RequireAuth>} />
        <Route path="/admin/swipe-check" element={<RequireAuth><SwipeCheck /></RequireAuth>} />
        <Route path="/admin/heart-animation" element={<RequireAuth><HeartAnimationScreen /></RequireAuth>} />
        <Route path="/admin/scatter-gallery" element={<RequireAuth><ScatterGalleryScreen /></RequireAuth>} />
        <Route path="/admin/qr-paper/design" element={<RequireAuth><QRPaperDesignSelect /></RequireAuth>} />
        <Route path="/admin/qr-paper/order" element={<RequireAuth><QRPaperOrderForm /></RequireAuth>} />
        <Route path="/admin/qr-paper/consent" element={<RequireAuth><QRPaperConsentForm /></RequireAuth>} />
        <Route path="/admin/qr-paper/confirm" element={<RequireAuth><QRPaperConfirmForm /></RequireAuth>} />
        
        {/* マソニーギャラリーデモ */}
        <Route path="/demo/masonry-gallery" element={<MasonryGalleryDemo />} />
      </Routes>
    </div>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <HelmetProvider>
      <RoomProvider>
        <ImageUpdateProvider>
          <AppWrapper />
        </ImageUpdateProvider>
      </RoomProvider>
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>
);

